'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventAdjudicatorIds = exports.adjudicatorsAreLoading = exports.eventAdjudicators = exports.adjudicatorsForFeis = exports.adjudicators = undefined;

var _immutable = require('immutable');

var adjudicators = exports.adjudicators = function adjudicators(state, aid) {
  return state.getIn(['adjudicators', 'one', aid]);
};
var adjudicatorsForFeis = exports.adjudicatorsForFeis = function adjudicatorsForFeis(state, fid) {
  return (state.getIn(['feiseanna', 'adjudicators', fid]) || (0, _immutable.List)()).map(function (aid) {
    return state.getIn(['adjudicators', 'one', aid]);
  });
};
var eventAdjudicators = exports.eventAdjudicators = function eventAdjudicators(state, eid) {
  return state.getIn(['events', 'adjudicators', eid]).map(function (aid) {
    return state.getIn(['adjudicators', 'one', aid]);
  });
};

var adjudicatorsAreLoading = exports.adjudicatorsAreLoading = function adjudicatorsAreLoading(state, aid) {
  return !state.getIn(['adjudicators', 'one', 'aid']) || state.getIn(['adjudicators', 'one', 'aid']);
};

var getEventAdjudicatorIds = exports.getEventAdjudicatorIds = function getEventAdjudicatorIds(state, eventId) {
  return state.getIn(['events', 'adjudicators', eventId]);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/adjudicators/paths.js
// module id = 56
// module chunks = 0